import { isExperimentActive } from 'shared/ab-testing'
import { ASPExperiment } from './interface'

/**
 * Prepares experiment flags based on active ASP experiment variations.
 * @param aspExperiments - Array of ASP experiments
 * @param rawExperiments - Raw experiment string used to determine active variations.
 * @param forceExperimentFlags - Experiment flags that were forcibly set via the `aspExperimentFlags` URL parameter.
 * @param rolledOutExperimentFlags - Base experiment flags for rolled out Galleries
 * @returns - Experiment flags with active variations applied.
 */
export const assembleASPExperimentFlags = (
  aspExperiments: ASPExperiment[],
  rawExperiments: string | undefined,
  forceExperimentFlags: Gallery.Models.Url.ASPExperimentFlags,
  rolledOutExperimentFlags?: Gallery.Models.Url.ASPExperimentFlags,
): Record<string, string> => {
  const aspExperimentFlags = aspExperiments.reduce(
    (flags, experiment) => {
      const activeVariation = Object.keys(experiment.variationsValueMap).find((variation) => isExperimentActive(variation, rawExperiments))

      if (!activeVariation) return flags
      return {
        ...flags,
        [experiment.experimentKey]: experiment.variationsValueMap[activeVariation],
      }
    },
    {} as Record<string, string>,
  )

  return {
    ...aspExperimentFlags,
    ...forceExperimentFlags,
    ...rolledOutExperimentFlags,
  }
}
